<template>
  <q-btn
    stack
    flat
    no-caps
    :icon="icon"
    :to="to"
    @click="_onClick"
    :label="label"
    size="14px"
    color="black"
    :style="style"
  >
  </q-btn>
</template>

<script>
import { QBtn } from 'quasar'

export default {
  props: {
    name: {
      type: String,
      required: true
    },
    tool: {
      type: Object,
      required: true
    },
    menu: {
      type: Boolean,
      default: false
    }
  },
  components: {
    QBtn
  },
  computed: {
    icon () {
      return this._getOrCall(this.tool.icon)
    },
    label () {
      return this.$t('tools.' + this.name + '.headerName')
    },
    to () {
      const value = this._getOrCall(this.tool.to)
      if (typeof value === 'string') {
        return { name: value }
      } else {
        return value
      }
    },
    style () {
      return {}
    }
  },
  methods: {
    emit (event, value) {
      if (typeof event === 'string' && event) {
        this.$emit('event', { name: event, value })
      } else if (typeof event === 'object' && event.name.toString()) {
        this.$emit('event', event)
      } else {
        this.$except('[HeaderItemHolder.vue] Trying to emit an incorrectly configured event. Check your config.')
      }
    },
    _onClick () {
      if (this.tool.to) {
        this.$router.push({ path: this.tool.to })
      }
      if (this.tool.action) {
        this.tool.action.call(this, this.tool)
      }
      if (this.tool.emit) {
        this.emit(this._getOrCall(this.tool.emit))
      }
    },
    _getOrCall (v) {
      if (v) {
        if (typeof v === 'function') {
          return v.call(this, this.tool)
        } else {
          return v
        }
      }
    }
  }
}
</script>

<style scoped>
.q-btn__content div {
  font-size: 10px;
}
</style>
